module.exports = __webpack_public_path__ + "static/media/ic_searchtype_restrictedarea.f93f1b87.svg";